"use strict";

window.APP = window.APP || {};

// Importar el validador WASM
import validator from '../wasm-validator.js';

APP.ActivationView = Backbone.View.extend({
  template: _.template($("#activationTemplate").html()),

  events: {
    "click #activateButton": "activate",
    "change #languageSelect": "changeLanguage"
  },

  initialize: function () {
    this.generateDeviceKey();
    // Inicializar el validador WASM
    validator.init().catch(err => console.warn('WASM init failed, using JS fallback:', err));
  },

  render: function () {
    this.$el.html(this.template({}));
    
    // Cargar la key del dispositivo
    const deviceKey = localStorage.getItem("key");
    this.$("#deviceKey").val(deviceKey);
    
    // Cargar el idioma guardado si existe
    const savedLanguage = localStorage.getItem("language") || "es";
    this.$("#languageSelect").val(savedLanguage);
    
    return this;
  },

  generateDeviceKey: function () {
    // Generar un código aleatorio único para el dispositivo si no existe
    if (!localStorage.getItem("key")) {
      const key = this.generateRandomKey();
      localStorage.setItem("key", key);
    }
  },

  generateRandomKey: function () {
    // Genera un código aleatorio de 16 caracteres (formato: XXXX-XXXX-XXXX-XXXX)
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let key = "";
    for (let i = 0; i < 16; i++) {
      if (i > 0 && i % 4 === 0) {
        key += "-";
      }
      key += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return key;
  },

  activate: async function (e) {
    e.preventDefault();
    
    const serial = this.$("#serialInput").val().trim();
    const deviceKey = this.$("#deviceKey").val();
    const errorContainer = this.$("#activationError");
    const language = this.$("#languageSelect").val();
    const activateButton = this.$("#activateButton");
    
    // Mensajes de error según idioma
    const errorMessages = {
      es: {
        empty: "Por favor ingrese el serial de activación",
        minLength: "El serial debe tener al menos 8 caracteres",
        invalid: "Serial inválido. Por favor verifique el código.",
        validating: "Validando..."
      },
      en: {
        empty: "Please enter the activation serial",
        minLength: "The serial must be at least 8 characters long",
        invalid: "Invalid serial. Please check the code.",
        validating: "Validating..."
      }
    };
    
    const messages = errorMessages[language];
    
    // Limpiar error previo
    errorContainer.text("");
    
    // Validar que se ingresó un serial
    if (!serial || serial.length === 0) {
      errorContainer.text(messages.empty);
      this.$("#serialInput").focus();
      return;
    }
    
    // Validar formato del serial (puedes ajustar esta validación según tus necesidades)
    if (serial.length < 8) {
      errorContainer.text(messages.minLength);
      this.$("#serialInput").focus();
      return;
    }
    
    // Deshabilitar botón mientras valida
    activateButton.prop('disabled', true);
    activateButton.text(messages.validating);
    
    try {
      // Validar serial contra el key usando WASM
      const isValid = await validator.validateSerial(deviceKey, serial);
      
      if (!isValid) {
        errorContainer.text(messages.invalid);
        this.$("#serialInput").focus();
        activateButton.prop('disabled', false);
        activateButton.text(language === 'es' ? 'Activar' : 'Activate');
        return;
      }
      
      // Guardar el serial en localStorage
      localStorage.setItem("serial", serial);
      
      // NO guardar el idioma aquí - lo hará la pantalla de selección de idioma
      // localStorage.setItem("language", language);
      
      console.log('Activation successful, redirecting to language selection...');
      
      // Redirigir a la pantalla de selección de idioma usando window.app (ruta raíz)
      if (window.app) {
        window.app.navigate("", { trigger: true });
      } else {
        // Fallback si el router no está disponible
        window.location.href = "/";
      }
    } catch (error) {
      console.error('Validation error:', error);
      errorContainer.text(messages.invalid);
      activateButton.prop('disabled', false);
      activateButton.text(language === 'es' ? 'Activar' : 'Activate');
    }
  },

  changeLanguage: function (e) {
    const language = $(e.currentTarget).val();
    localStorage.setItem("language", language);
    
    // Actualizar textos de la pantalla según el idioma
    this.updateLanguageTexts(language);
  },

  updateLanguageTexts: function (language) {
    const texts = {
      es: {
        title: "Activación del Dispositivo",
        deviceKeyLabel: "Código del Dispositivo",
        serialLabel: "Serial de Activación",
        serialPlaceholder: "Ingrese el serial",
        languageLabel: "Idioma / Language",
        activateButton: "Activar"
      },
      en: {
        title: "Device Activation",
        deviceKeyLabel: "Device Code",
        serialLabel: "Activation Serial",
        serialPlaceholder: "Enter serial",
        languageLabel: "Language / Idioma",
        activateButton: "Activate"
      }
    };
    
    const t = texts[language];
    
    this.$(".activation-container__title").text(t.title);
    this.$("label").eq(0).text(t.deviceKeyLabel);
    this.$("label").eq(1).text(t.serialLabel);
    this.$("#serialInput").attr("placeholder", t.serialPlaceholder);
    this.$("label").eq(2).text(t.languageLabel);
    this.$("#activateButton").text(t.activateButton);
  }
});
